/* @flow */
import Image from 'components/Image.jsx';
import PaymentSource from 'entities/PaymentSource';
import React from 'react';

const IMAGES = {
  'american express': require('assets/images/payments/cards/cc_americanexpress.svg'),
  discover: require('assets/images/payments/cards/cc_discover.svg'),
  mastercard: require('assets/images/payments/cards/cc_mastercard.svg'),
  visa: require('assets/images/payments/cards/cc_visa.svg'),
};

import DEFAULT from 'assets/images/payments/cards/cc_other.svg';

export default React.createClass({
  propTypes: {
    paymentSource: React.PropTypes.instanceOf(PaymentSource).isRequired,
  },

  render() {
    const { paymentSource, ...rest } = this.props;

    const match = IMAGES[paymentSource.getBrand().toLowerCase()];
    const source = match || DEFAULT;

    return <Image src={source} {...rest} />;
  },
});



// WEBPACK FOOTER //
// ./src/payments/components/CardLogo.jsx